<template>
  <v-alert
      text
      :color="color"
      v-if="alert.is_active && !alert.is_confirmed"
  >
    <h3 class="headline mb-3">{{ getTitle(alert.type) }}</h3>
    <div>{{ alert.description }}</div>

    <v-divider
        class="my-4"
        :class="color"
        style="opacity: 0.22"
        v-if="color !== 'warning'"
    ></v-divider>

    <v-row
        align="center"
        no-gutters
    >
      <div class="flex-grow-1"></div>
      <v-col class="shrink">
        <v-btn
            :disabled="disabled || loading"
            :color="color"
            outlined
            @click.stop="confirmAlert()"
        >
          {{ label }}
        </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>
<script>
import {errorNotification} from "@/components/utils";

export default {
  components: {},
  name: 'ApplicationAlert',
  props: {
    id: Number,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      alert: {},
      loading: false,
      minimize: false
    }
  },
  computed: {
    color: function () {
      switch (this.alert.type) {
        case 'confirmation':
          return 'success'
        case 'upload':
          return 'info'
        case 'info':
          return 'info'
        case 'warning':
          return 'warning'
      }
      return 'info'
    },
    label: function () {
      let caption = ''
      switch (this.alert.type) {
        case 'info':
          caption = 'Noted'
          break
        case 'upload':
          caption = 'Done'
          break
        case 'confirmation':
          caption = 'Confirm'
          break
        default:
          caption = 'Confirm'
      }
      return caption
    }
  },
  methods: {
    fetchData() {
      this.$axios.get('/applications/' + this.id + '/alert/', {})
          .then((response) => {
            this.$set(this, 'alert', response.data)
          })
          .catch((error) => {
            errorNotification(error)
          })
    },
    getTitle(type) {
      switch (type) {
        case 'confirmation':
          return 'Action Required!'
        case 'upload':
          return 'Documents Required!'
        case 'info':
          return 'Information'
        case 'warning':
          return 'Warning!'
      }
      return 'Information'
    },
    confirmAlert() {
      this.loading = true
      this.$axios.post('/applications/' + this.id + '/alert/', {})
          .then((response) => {
            this.loading = false
            this.$set(this, 'alert', response.data)
          })
          .catch((error) => {
            errorNotification(error)
          })
          .finally(() => {
            this.loading = false
          })
    }
  },
  mounted() {
    this.fetchData()
  }
}
</script>